import { Directive, Input, forwardRef } from '@angular/core';
import { NgForm, ControlContainer, AbstractControl, FormGroup, Form, AbstractFormGroupDirective, NgModelGroup } from '@angular/forms';


export let controlContainerFactory = (formProvider: DynamicFormProviderDirective) => {
    return formProvider.form;
};

@Directive({
    selector: '[dynamicFormProvider]',
    providers: [{
            provide: ControlContainer,
            useFactory: controlContainerFactory,
            deps: [DynamicFormProviderDirective]
        }],
    standalone: false
})
export class DynamicFormProviderDirective {
    @Input('dynamicFormProvider') form: NgForm;
}